<template>
  <div
    class="
      tw-absolute
      tw-right-2
      tw-w-14
      tw-h-full
      tw-flex
      tw-items-center
      tw-justify-end
      tw-opacity-0
      group-hover:tw-opacity-100
      tw-pointer-events-none
    "
    :class="background"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <a
      v-tooltip.html="tooltip"
      class="
        tw-pointer-events-auto tw-rounded tw-text-sf-gray-dark
        hover:tw-text-sf-gray-dark hover:tw-bg-sf-gray-dark/25
        tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-no-underline
        hover:tw-no-underline
      "
      :class="{ 'tw-opacity-50 tw-cursor-not-allowed': disabled }"
      data-testid="unmark-button"
      :data-heap="`${trackingPrefix}-review-status-${trackingAction}`"
      @click.stop.prevent="unmark"
    >
      <i class="fa fa-close tw-text-lg tw-leading-none" />
    </a>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  tooltip: string
  background: string
  trackingPrefix: string
  trackingAction: string
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<{ unmark: []; onMouseEnter: []; onMouseLeave: [] }>()

function unmark() {
  if (props.disabled) return
  emit('unmark')
}

function onMouseEnter() {
  emit('onMouseEnter')
}

function onMouseLeave() {
  emit('onMouseLeave')
}
</script>
